module.exports = __webpack_public_path__ + "img/zhxy_image_1.76a670d2.png";